import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/photos`;
const token = localStorage.getItem("token");

/// GET
// Fonction pour récupérer toutes les photos d'une compétition par son id
export const getAllPhotosByCompetitionId = async (competitionId) => {
  try {
    const response = await axios.get(`${apiUrl}/competition/${competitionId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors du chargement des photos:", error);
    return []; // Renvoie un tableau vide en cas d'échec pour maintenir la cohérence du type de retour
  }
};

// Fonction pour récupérer une photo par son id
export const getPhotoById = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors du chargement de la photo:", error);
    return null; // Renvoie null en cas d'échec pour maintenir la cohérence du type de retour
  }
};

/// POST
// Fonction pour ajouter une photo
export const addPhoto = async (newPhoto) => {
  try {
    const response = await axios.post(`${apiUrl}/addPhoto`, newPhoto, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (response.status !== 201) throw new Error("Échec ajout photo");
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout d'une photo:", error);
    throw error;
  }
};

// Fonction pour ajouter plusieurs photos
export const addMultiplePhotos = async (photos) => {
  try {
    const response = await axios.post(`${apiUrl}/addMultiplePhotos`, photos, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 201) throw new Error("Failed to add new photos");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors de l'ajout de plusieurs photos:", error);
    return null; // Renvoie null en cas d'échec pour maintenir la cohérence du type de retour
  }
};

/// PUT
// Fonction pour modifier une photo avec son id
export const updatePhoto = async (id, updatedPhoto) => {
  try {
    const response = await axios.put(`${apiUrl}/${id}`, updatedPhoto, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to update photo");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors de la modification d'une photo:", error);
    return null; // Renvoie null en cas d'échec pour maintenir la cohérence du type de retour
  }
};

/// DELETE
// Fonction pour supprimer une photo avec son id
export const deletePhoto = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    // Vérifie si la réponse est correcte
    if (response.status !== 200) throw new Error("Failed to delete photo");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors de la suppression d'une photo:", error);
    return null; // Renvoie null en cas d'échec pour maintenir la cohérence du type de retour
  }
};
